module.exports = __webpack_public_path__ + "static/img/10.14b9345.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/10.png
// module id = ac15
// module chunks = 0